import React from 'react';
import styled from 'styled-components';
import { useNotification } from '../contexts/NotificationContext';
import NotificationItem from './NotificationItem';

const Container = styled.div`
  position: fixed;
  top: 2rem;
  right: 2rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 400px;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    top: 1rem;
    right: 1rem;
    left: 1rem;
    max-width: none;
  }
`;

const NotificationContainer: React.FC = () => {
  const { notifications } = useNotification();

  return (
    <Container>
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
        />
      ))}
    </Container>
  );
};

export default NotificationContainer;